import api from "@/services/api";

// corporateService.js

const _http = {

  async getAll() {                    // Ubah jadi getAll() agar konsisten
    try {
      const response = await api.get("/corporate");   // pastikan endpoint benar
      return response;   // kembalikan full response, bukan hanya data
    } catch (error) {
      console.error("Corporate Service Error:", error.response?.data || error.message);
      throw error;
    }
  },

  // Tambahkan method lain kalau dibutuhkan nanti
  async getById(id) {
    return await api.get(`/corporate/${id}`);
  }
};




export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAll(query);

      return {
        data: res.data.data.map((item) => item),
      };
    } catch (error) {
      console.error(error);

      return {
        data: [],
      };
    }
  },
};

